var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPresentationScreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 304H80V80H32V320C32 337.602 46.4 352 64 352H264V399.016L192 471.016C182.646 480.367 182.646 495.535 192 504.891L192.006 504.895C201.354 514.242 216.508 514.25 225.865 504.91L288 442.891L350.094 504.984C359.484 514.375 374.723 514.332 384.062 504.891C393.363 495.484 393.32 480.336 383.969 470.984L312 399.016V352H512C529.6 352 544 337.602 544 320V80H496V304ZM552.045 0H23.955C10.725 0 0 10.727 0 23.953V24.047C0 37.273 10.725 48 23.955 48H552.045C565.275 48 576 37.273 576 24.047V23.953C576 10.727 565.275 0 552.045 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentationScreen);
export default __webpack_public_path__ + "static/media/presentation-screen.25075cd0d78ee7c33e9e5e2ebc26d4be.svg";
export { ForwardRef as ReactComponent };